export const environment = {
  apiBaseUrl: 'api/v2',
  lpBaseUrl: 'https://lp.panoptyc.com',
  nodeEnv: 'Production',
  production: true,
  auth0ClientId: 'jSZhyoSpizL36zZ04wA5Lv4Tvx7MFbVp',
  auth0Domain: 'panoptyc.us.auth0.com',
  auth0Audience: 'https://api.panoptyc.co',
  posthogApiKey: 'phc_LNFyPfZzwvFgA9i1rTMbFikBSG6C8TSffpOFWMbmL6',
  agGridKey:
    // eslint-disable-next-line max-len
    'Using_this_{AG_Grid}_Enterprise_key_{AG-088012}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Panoptyc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Panoptyc}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Panoptyc}_need_to_be_licensed___{Panoptyc}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{12_May_2026}____[v3]_[01]_MTc3ODU0MDQwMDAwMA==c3eecb8e97133bceb8310897e47935b3',
  customerIOKey: '5912d90f48898849c1a1',
  customerIOSiteId: '3f7c5910ab00286e6e5f',
  suspectImageUrlConfigs: [
    { base_url: 'https://freedomcircle.s3.us-east-2.amazonaws.com/photos', ext: '.jpg' },
    { base_url: 'https://freedomcircle.s3.us-east-2.amazonaws.com/photos', ext: '.jpeg' },
    { base_url: 'https://test365storage.blob.core.windows.net/cancelimages', ext: '.jpg' },
    { base_url: 'https://storage.panoptyc.com', ext: '.jpg' },
    { base_url: 'https://storage.panoptyc.com', ext: '.jpeg' },
  ],
};
